<template>
  <div
    class="message-preview"
    @click="$emit('set-active', message)"
    :class="{ 'is-active': isActive, 'is-new': !message.is_read }"
  >
    <div class="message-preview__info">
      <span class="message-preview__heading">
        <strong v-if="endpoint.id === 'all'"
          >{{ message.form_name || 'form_name' }}
        </strong>
        {{ message.heading }}
      </span>
      <span class="message-preview__date">{{
        message.date
      }}</span>
    </div>

    <div class="message-preview__actions">
      <category-control :message="message" @change="$emit('update')" />
    </div>
  </div>
</template>

<script>
import CategoryControl from './controls/category-control.vue'
export default {
  name: 'message-preview',
  components: { CategoryControl },
  props: {
    message: Object,
    isActive: Boolean
  },
  computed: {
    endpoint() {
      return this.$store.getters.endpoint
    }
  }
}
</script>

<style lang="scss" scoped>
.message-preview {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.75rem 1rem 0.75rem 2rem;
  background-color: $gray-300;
  border-bottom: 1px solid $gray-400;
  cursor: pointer;
  transition: 0.2s;
  &:before {
    position: absolute;
    top: 50%;
    left: 0.75rem;
    width: 10px;
    height: 10px;
    background-color: $primary;
    border-radius: 50%;
    transform: translateY(-50%);
    opacity: 0;
    transition: 0.2s;
    content: '';
  }
  &.is-new {
    background: $white;
    &:before {
      opacity: 1;
    }
    .message-preview__heading {
      font-weight: bold;
    }
  }
  &__heading {
    strong {
      display: block;
      margin-bottom: 4px;
      font-size: 14px;
      line-height: 1;
    }
  }
  &__date {
    margin-top: 8px;
    color: $gray-500;
    font-size: 0.8rem;
  }
  &__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    max-width: 240px;
  }
  &__actions {
    display: flex;
    align-items: center;
    margin-left: auto;
    & > * {
      margin-right: 1rem;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .category-control {
    visibility: hidden;
    opacity: 0;
    transition: 0.2s;
  }
  &:hover {
    .category-control {
      visibility: visible;
      opacity: 1;
    }
  }
  &:first-child {
    border-radius: 4px 4px 0 0;
  }
  &:last-child {
    border-radius: 0 0 4px 4px;
  }
  &:hover {
    background-color: rgba($primary, 0.1);
  }
  &.is-active {
    color: $white;
    background-color: $primary;
    .message-preview__date {
      color: $gray-300;
    }
  }
}
</style>
